import Headline from '@common/components/headline/Headline';
import { MoneyGateBank } from '@features/deposit/screens/money-gate/api/moneyGate.type';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import React, { FC, Fragment, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

interface IMoneyGateBanksProps {
  banks: MoneyGateBank[];
  orderId: string;
  onSelectBank: ({ orderId, bank, type }: { orderId: string, bank: string, type: string }) => void;
  handleChangeActiveStep: ({ step, bank }: { step: number, bank: MoneyGateBank }) => void;
  disabled: boolean;
}
interface IHandleSelectBank {
  step: number,
  orderId: string,
  bank: MoneyGateBank,
  bankName: string,
  type: string
}

const DepositOnlineMoneyGateBanks: FC<IMoneyGateBanksProps> = ({
  banks,
  onSelectBank,
  orderId,
  handleChangeActiveStep,
  disabled,
}) => {

  const handleSelectBank = useCallback(({ step, orderId, bank, bankName, type }: IHandleSelectBank) => {
    handleChangeActiveStep({ step, bank });
    onSelectBank({ orderId, bank: bankName, type });
  }, [ handleChangeActiveStep, onSelectBank ]);

  return (
    <Fragment>

      <Headline
        title={<FormattedMessage id="CHOOSE_YOUR_BANK" defaultMessage="ПОПОЛНЕНИЕ СЧЕТА"/>}
        gutterBottom
      />
      <Box  marginTop={2} paddingX={1}>
        <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2} my={2}>

          {banks.map((bank, index) => (
            <Card key={index}  sx={{ height: 120, bgcolor: '#fff' }} onClick={() => handleSelectBank({
              step: 1,
              orderId,
              bank: bank,
              bankName: bank.bank,
              type: bank.paymentType,
            })}>
                <CardMedia
                  component="img"
                  image={`/deposit/money-gate/${bank.bank}.png`}
                  alt={bank.bankName}
                  height="100%"
                  sx={{
                    objectFit: 'contain',
                    py: 2,
                  }}
                />
            </Card>
          ))}
        </Box>
      </Box>

    </Fragment>
  );
};

export default DepositOnlineMoneyGateBanks;